(function () {
  "use strict";

  function render() {
    const api = window.NutricellsInstructionPlan;
    if (!api) return;
    const plan = api.fromSearch(window.location.search);
    document.querySelectorAll("[data-nc-sample-content]").forEach(container => {
      if (!plan) return; // Keep the server-rendered card guidance for missing or invalid links.
      const summary = document.createElement("p");
      const strong = document.createElement("strong");
      strong.textContent = `${plan.amounts.length} Röhrchen · ${api.formatAmount(plan.total, plan.decimals)} gesamt`;
      summary.appendChild(strong);
      const list = document.createElement("ul");
      plan.amounts.forEach((amount, index) => {
        const item = document.createElement("li");
        item.textContent = `Röhrchen ${index + 1}: bis ${api.formatAmount(amount, plan.decimals)} befüllen.`;
        list.appendChild(item);
      });
      const note = document.createElement("p");
      note.textContent = "Diese Mengen gehören zu deinem Anleitungs-QR-Code. Du findest sie auch auf deiner beiliegenden QR-Karte.";
      container.replaceChildren(summary, list, note);
      container.dataset.ncSampleState = "individual";
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", render, { once: true });
  else render();
  document.addEventListener("shopify:section:load", render);
})();
